/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

const { events } = require("./events/index");

const GeneralSection = {
    events
}

export { GeneralSection };
